export default __webpack_public_path__ + "static/media/project3_mockup.6521deab.png";